import { useDocumentVisibility, useIntervalFn } from '@vueuse/core';

export function usePortalFormProgressPolling(
    refresh: () => Promise<unknown> | unknown,
    intervalMs = 15_000,
) {
    const visibility = useDocumentVisibility();

    const controls = useIntervalFn(() => {
        if (visibility.value !== 'visible') return;
        void refresh();
    }, intervalMs);

    return controls;
}
